import { render, staticRenderFns } from "./LabsPanel.vue?vue&type=template&id=23fc7ea4&"
import script from "./LabsPanel.vue?vue&type=script&lang=js&"
export * from "./LabsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports